'use client';

import LoginForm from './components/LoginForm';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

export default function AdminLoginPage() {
  const router = useRouter();
  const { user, loading, isAdmin, profileLoading } = useAuth();
  const [isReady, setIsReady] = useState(false);

  // SAME LOGIC – DO NOT TOUCH
  useEffect(() => {
    if (!loading && !profileLoading && isReady) {
      if (user && isAdmin) {
        router.replace('/admin-dashboard');
      } else if (user && !isAdmin) {
        router.replace('/login');
      }
    }
  }, [loading, profileLoading, user, isAdmin, isReady, router]);

  useEffect(() => {
    setIsReady(true);
  }, []);

  // SIMPLE LOADER (OLD STYLE)
  if (loading || profileLoading || !isReady) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Loading Admin Panel...</p>
        </div>
      </div>
    );
  }

  // OLD CLEAN ADMIN UI
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        
        {/* Header */}
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-primary flex items-center justify-center">
            <svg
              className="h-7 w-7 text-primary-foreground"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5s-3 1.343-3 3 1.343 3 3 3zm0 0c-2.761 0-5 2.239-5 5v1h10v-1c0-2.761-2.239-5-5-5z"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-foreground">
            Admin Login
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Authorized administrators only
          </p>
        </div>

        {/* Card */}
        <div className="bg-card border border-border rounded-lg shadow-lg p-8">
          <LoginForm />
        </div>

        {/* Back link */}
        <div className="text-center mt-6">
          <a
            href="/product-catalog"
            className="text-sm text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Website
          </a>
        </div>
      </div>
    </div>
  );
}